import React, { useEffect, useState } from 'react';
import { Grid, Button, CircularProgress, Typography, Box } from "@mui/material";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { styles as inputStyles } from "common/inputStyles";
import ReportsTableHeader from 'components/TableHeader/ReportsTableHeader';
import { Colors } from "assets/colors";
import { getAllFailedReports } from 'apis/device';
import ErrorDataTable from 'components/DataTable/errorDataTable';
import { styles } from "../ErrorReports/styles";
import ErrorPopup from 'common/ErrorPopup';
import CommonUtil from 'common/CommonUtil';
import moment from "moment";
import { CSVLink } from "react-csv";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

interface ErrorReportsProps {
  csvLabel?: string;
}

var pgNumber = 0;
var records:any = [];
const ErrorReports: React.FC<ErrorReportsProps> = ({csvLabel}) => {
  const [allRows, setAllRows] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [original, setOriginal] = useState<any>([]);
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorReportData, setErrorReportData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");
  const [fromDate, setFromDate] = useState<any>('');
  const [toDate, setToDate] = useState<any>('');
  const [truckId, setTruckId] = useState("");
  const [deviceId, setDeviceId] = useState("");
  const [showErrorPopup,setShowErrorPopup] = useState(false);
  const [formattedData, setFormattedData] = useState<any>(null);
  const [errRepDataAfterFilter, setErrRepDataAfterFilter] = useState([]);

  useEffect(() => {
  console.log(fromDate, toDate)
  }, [fromDate, toDate]);

  useEffect(() => {
    if (searchVal && searchVal !== "") {
        let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);


  const getFailedReports = async () => {

    setErrorReportData([]);
      records = [];
       pgNumber = 1;
       let newTruckId = truckId.replace(/\s+/g, "");
       let newDId = deviceId.replace(/\s+/g, "");
       //console.log(RemovedSpaceString);
      //console.log(truckId.trim())
      let data = await getAllFailedReports(newTruckId, newDId, pgNumber);
      if (data) {
        records = records.concat(data.records);
        if(data.hasMore){
          while(true){
            pgNumber = pgNumber + 1;
            data = await getAllFailedReports(truckId, deviceId,pgNumber);
            if(data){
                records = records.concat(data.records);
            }
            if(records.length>=CommonUtil.RECORD_COUNT){
              setShowErrorPopup(true);
              break;
            }
            if(!data.hasMore){
              break;
            }
          }
        }
        records.forEach((object: any) => {
          if ('eventTimestampMillis' in object && object.eventTimestampMillis !== null) {
            const date = new Date(object.creationDate);
            object.eventTimestampMillis = moment(date).local().format('MM/DD/YYYY h:mm:ss A');
          }
          if ('eventTimestamp' in object && object.eventTimestamp !== null) {
            object.eventTimestamp = new Date(object.eventTimestamp).toLocaleString();
            //object.eventTimestamp = moment(object).format('MM/DD/YYYY h:mm:ss A');
          }
          if ('receivedTimestamp' in object && object.receivedTimestamp !== null) {
            object.receivedTimestamp = new Date(object.receivedTimestamp).toLocaleString();
          }
        });
        const sortedArray = records.sort((a: any, b: any) => {
          // Convert the lastUpdateDate strings to Date objects
          const dateA = new Date(a.eventTimestampMillis);
          const dateB = new Date(b.eventTimestampMillis);

          // Compare the dates and return the result
          if (dateA > dateB) {
            return -1;
          } else if (dateA < dateB) {
            return 1;
          } else {
            return 0;
          }
        });
        let newArr = sortedArray.filter((s: any) => s.creationDate !== null);
        setErrorReportData(sortedArray);
      }
      else {
        pgNumber = 0;
        setErrorReportData([]);
        setIsLoading(false);
      }
  }
  useEffect(() => {
    pgNumber = 0;
    records = [];
  }, [])


  const closeErrorPopup = ()=>{
    setShowErrorPopup(false);
  }
    // Downloading Only Filtered Data After Search
    const updateFilteredData = (data:[]) => {
      setErrRepDataAfterFilter(data);
    }

  return (
    <Grid container spacing={2}>
      {showModal ? (err !== "" && <Typography sx={styles.errContainer}>{err}</Typography>) : ""}
      {showErrorPopup?<ErrorPopup title='Data' popupText='10000 records loaded from Available data' open={showErrorPopup} handlePopupClose={closeErrorPopup}></ErrorPopup>:""}
      <ReportsTableHeader  getFailedReports={getFailedReports} setFromDate={setFromDate} setToDate={setToDate} setErrorReportData={setErrorReportData} data={errRepDataAfterFilter} truckId={truckId} setTruckId={setTruckId} deviceId={deviceId} setDeviceId={setDeviceId} formattedData={formattedData} setFormattedData={setFormattedData} csvLabel={"FailedReports.csv"} />
      <Grid item xs={12} sx={{ height: "80vh" }}>
        {isLoading && <CircularProgress sx={{ marginBottom: "1rem", display: "grid", alignItems: "center" }} />}
        <Grid item xs={12} style={{display:'flex', justifyContent:'flex-end'}}>
        <Grid>
        <CSVLink data={formattedData || []} style={{ textDecoration: 'none' }} filename={csvLabel ? csvLabel : 'FailedReports.csv'}>
          <Button sx={{...styles.csvbutton, backgroundColor: Colors.Purple}}>
            <FileDownloadOutlinedIcon sx={{ marginRight: ".5rem" }} />
            Download CSV
          </Button>
        </CSVLink>
        </Grid>
        <Box sx={inputStyles.searchContainer} style={{marginBottom: '15px'}}>
          <SearchOutlinedIcon sx={{ marginLeft: ".5rem",}} />
          <input type="text" placeholder='Search' value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
        </Box>
        </Grid>
         {/* Added Filtered data Download after Search (getFilteredData={updateFilteredData} ) */}
        <ErrorDataTable data={errorReportData} searchVal={searchVal} getFilteredData={updateFilteredData}/>
      </Grid>
    </Grid>
  )
}

export default ErrorReports;